// lesson 2.1
export const conjVerbsSet1 = [
  {
    verb: 'Работа<strong>ть</strong>',
    tense: 'Present tense',
    set: [
      'Я работа<strong>ю</strong>',
      'Ты работа<strong>ешь</strong>',
      'Он работа<strong>ет</strong>',
      'Она работа<strong>ет</strong>',
      'Оно работа<strong>ет</strong>',
      'Вы работа<strong>ете</strong>',
      'Мы работа<strong>ем</strong>',
      'Они работа<strong>ют</strong>'
    ]
  },
  {
    verb: 'Обеда<strong>ть</strong>',
    tense: 'Present tense',
    set: [
      'Я Обеда<strong>ю</strong>',
      'Ты Обеда<strong>ешь</strong>',
      'Он Обеда<strong>ет</strong>',
      'Она Обеда<strong>ет</strong>',
      'Оно Обеда<strong>ет</strong>',
      'Вы Обеда<strong>ете</strong>',
      'Мы Обеда<strong>ем</strong>',
      'Они Обеда<strong>ют</strong>'
    ]
  },
  {
    verb: 'Ужина<strong>ть</strong>',
    tense: 'Present tense',
    set: [
      'Я ужина<strong>ю</strong>',
      'Ты ужина<strong>ешь</strong>',
      'Он ужина<strong>ет</strong>',
      'Она ужина<strong>ет</strong>',
      'Оно ужина<strong>ет</strong>',
      'Вы ужина<strong>ете</strong>',
      'Мы ужина<strong>ем</strong>',
      'Они ужина<strong>ют</strong>'
    ]
  },
  {
    verb: 'Завтрака<strong>ть</strong>',
    tense: 'Present tense',
    set: [
      'Я завтрака<strong>ю</strong>',
      'Ты завтрака<strong>ешь</strong>',
      'Он завтрака<strong>ет</strong>',
      'Она завтрака<strong>ет</strong>',
      'Оно завтрака<strong>ет</strong>',
      'Вы завтрака<strong>ете</strong>',
      'Мы завтрака<strong>ем</strong>',
      'Они завтрака<strong>ют</strong>'
    ]
  }
];

// lesson 2.1
export const conjVerbsSet1_2 = [
  {
    verb: 'Ид<strong>ти</strong>',
    tense: 'Present tense',
    set: [
      'Я ид<strong>у</strong>',
      'Ты ид<strong>ёшь</strong>',
      'Он ид<strong>ет</strong>',
      'Она ид<strong>ет</strong>',
      'Оно ид<strong>ет</strong>',
      'Вы ид<strong>ёте</strong>',
      'Мы ид<strong>ём</strong>',
      'Они ид<strong>ут</strong>'
    ]
  },
  {
    verb: 'Встава<strong>ть</strong>',
    tense: 'Present tense',
    set: [
      'Я вста<strong>ю</strong>',
      'Ты вста<strong>ёшь</strong>',
      'Он вста<strong>ёт</strong>',
      'Она вста<strong>ёт</strong>',
      'Оно вста<strong>ёт</strong>',
      'Вы вста<strong>ёте</strong>',
      'Мы вста<strong>ём</strong>',
      'Они вста<strong>ют</strong>'
    ]
  }
];

// conjVerbsSet2 - одеваться
export const conjVerbsSet2 = [
  {
    verb: 'Одева<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я одева<strong>ю</strong>сь',
      'Ты одева<strong>ешь</strong>ся',
      'Он одева<strong>ет</strong>ся',
      'Она одева<strong>ет</strong>ся',
      'Оно одева<strong>ет</strong>ся',
      'Вы одева<strong>ете</strong>сь',
      'Мы одева<strong>ем</strong>ся',
      'Они одева<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Одева<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) одева<strong>ть</strong>ся',
      'Ты(будешь) одева<strong>ть</strong>ся',
      'Он(будет) одева<strong>ть</strong>ся',
      'Она(будет) одева<strong>ть</strong>ся',
      'Оно(будет) одева<strong>ть</strong>ся',
      'Вы(будете) одева<strong>ть</strong>ся',
      'Мы(будем) одева<strong>ть</strong>ся',
      'Они(будут) одева<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Оде<strong>ть</strong>ся',
    tense: 'Future tense (perfect)',
    set: [
      'Я оде<strong>ну</strong>сь',
      'Ты оде<strong>нешь</strong>ся',
      'Он оде<strong>нет</strong>ся',
      'Она оде<strong>нет</strong>ся',
      'Оно оде<strong>нет</strong>ся',
      'Вы оде<strong>нете</strong>сь',
      'Мы оде<strong>нем</strong>ся',
      'Они оде<strong>нут</strong>ся'
    ]
  },
  {
    verb: 'Одева<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я оде<strong>вал</strong>ся',
      'Ты оде<strong>вал</strong>ся',
      'Он оде<strong>вал</strong>ся',
      'Она оде<strong>вала</strong>сь',
      'Оно оде<strong>вало</strong>сь',
      'Вы оде<strong>вали</strong>сь',
      'Мы оде<strong>вали</strong>сь',
      'Они оде<strong>вали</strong>сь'
    ]
  },
  {
    verb: 'Оде<strong>ть</strong>ся',
    tense: 'Past tense (perfect)',
    set: [
      'Я оде<strong>л</strong>ся',
      'Ты оде<strong>л</strong>ся',
      'Он оде<strong>л</strong>ся',
      'Она оде<strong>ла</strong>сь',
      'Оно оде<strong>ло</strong>сь',
      'Вы оде<strong>ли</strong>сь',
      'Мы оде<strong>ли</strong>сь',
      'Они оде<strong>ли</strong>сь'
    ]
  }
];

// conjVerbsSet3 - мыться/помыться
export const conjVerbsSet3 = [
  {
    verb: 'Мы<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я мо<strong>ю</strong>сь',
      'Ты мо<strong>ешь</strong>ся',
      'Он мо<strong>ет</strong>ся',
      'Она мо<strong>ет</strong>ся',
      'Оно мо<strong>ет</strong>ся',
      'Вы мо<strong>ете</strong>сь',
      'Мы мо<strong>ем</strong>ся',
      'Они мо<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Мы<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) мы<strong>ть</strong>ся',
      'Ты(будешь) мы<strong>ть</strong>ся',
      'Он(будет) мы<strong>ть</strong>ся',
      'Она(будет) мы<strong>ть</strong>ся',
      'Оно(будет) мы<strong>ть</strong>ся',
      'Вы(будете) мы<strong>ть</strong>ся',
      'Мы(будем) мы<strong>ть</strong>ся',
      'Они(будут) мы<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Помы<strong>ть</strong>ся',
    tense: 'Future tense (perfect)',
    set: [
      'Я помо<strong>ю</strong>сь',
      'Ты помо<strong>ешь</strong>ся',
      'Он помо<strong>ет</strong>ся',
      'Она помо<strong>ет</strong>ся',
      'Оно помо<strong>ет</strong>ся',
      'Вы помо<strong>ете</strong>сь',
      'Мы помо<strong>ем</strong>ся',
      'Они помо<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Мы<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я мы<strong>л</strong>ся',
      'Ты мы<strong>л</strong>ся',
      'Он мы<strong>л</strong>ся',
      'Она мы<strong>ла</strong>сь',
      'Оно мы<strong>ло</strong>сь',
      'Вы мы<strong>ли</strong>сь',
      'Мы мы<strong>ли</strong>сь',
      'Они мы<strong>ли</strong>сь'
    ]
  },
  {
    verb: 'Помы<strong>ть</strong>ся',
    tense: 'Past tense (perfect)',
    set: [
      'Я помы<strong>л</strong>ся',
      'Ты помы<strong>л</strong>ся',
      'Он помы<strong>л</strong>ся',
      'Она помы<strong>ла</strong>сь',
      'Оно помы<strong>ло</strong>сь',
      'Вы помы<strong>ли</strong>сь',
      'Мы помы<strong>ли</strong>сь',
      'Они помы<strong>ли</strong>сь'
    ]
  }
];

// conjVerbsSet3 - бриться/побриться
export const conjVerbsSet4 = [
  {
    verb: 'Бри<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я бре<strong>ю</strong>сь',
      'Ты бре<strong>ешь</strong>ся',
      'Он бре<strong>ет</strong>ся',
      'Она бре<strong>ет</strong>ся',
      'Оно бре<strong>ет</strong>ся',
      'Вы бре<strong>ете</strong>сь',
      'Мы бре<strong>ем</strong>ся',
      'Они бре<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Бри<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) бри<strong>ть</strong>ся',
      'Ты(будешь) бри<strong>ть</strong>ся',
      'Он(будет) бри<strong>ть</strong>ся',
      'Она(будет) бри<strong>ть</strong>ся',
      'Оно(будет) бри<strong>ть</strong>ся',
      'Вы(будете) бри<strong>ть</strong>ся',
      'Мы(будем) бри<strong>ть</strong>ся',
      'Они(будут) бри<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Побри<strong>ть</strong>ся',
    tense: 'Future tense (perfect)',
    set: [
      'Я побре<strong>ю</strong>сь',
      'Ты побре<strong>ешь</strong>ся',
      'Он побре<strong>ет</strong>ся',
      'Она побре<strong>ет</strong>ся',
      'Оно побре<strong>ет</strong>ся',
      'Вы побре<strong>ете</strong>сь',
      'Мы побре<strong>ем</strong>ся',
      'Они побре<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Бри<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я бри<strong>л</strong>ся',
      'Ты бри<strong>л</strong>ся',
      'Он бри<strong>л</strong>ся',
      'Она бри<strong>ла</strong>сь',
      'Оно бри<strong>ло</strong>сь',
      'Вы бри<strong>ли</strong>сь',
      'Мы бри<strong>ли</strong>сь',
      'Они бри<strong>ли</strong>сь'
    ]
  },
  {
    verb: 'Побри<strong>ть</strong>ся',
    tense: 'Past tense (perfect)',
    set: [
      'Я побри<strong>л</strong>ся',
      'Ты побри<strong>л</strong>ся',
      'Он побри<strong>л</strong>ся',
      'Она побри<strong>ла</strong>сь',
      'Оно побри<strong>ло</strong>сь',
      'Вы побри<strong>ли</strong>сь',
      'Мы побри<strong>ли</strong>сь',
      'Они побри<strong>ли</strong>сь'
    ]
  }
];

export const conjVerbsSet5 = [
  {
    verb: 'Краси<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я краш<strong>у</strong>сь',
      'Ты крас<strong>ишь</strong>ся',
      'Он крас<strong>ит</strong>ся',
      'Она крас<strong>ит</strong>ся',
      'Оно крас<strong>ит</strong>ся',
      'Вы крас<strong>ите</strong>сь',
      'Мы крас<strong>им</strong>ся',
      'Они крас<strong>ят</strong>ся'
    ]
  },
  {
    verb: 'Краси<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) краси<strong>ть</strong>ся',
      'Ты(будешь) краси<strong>ть</strong>ся',
      'Он(будет) краси<strong>ть</strong>ся',
      'Она(будет) краси<strong>ть</strong>ся',
      'Оно(будет) краси<strong>ть</strong>ся',
      'Вы(будете) краси<strong>ть</strong>ся',
      'Мы(будем) краси<strong>ть</strong>ся',
      'Они(будут) краси<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Накраси<strong>ть</strong>ся',
    tense: 'Future tense (perfect)',
    set: [
      'Я накраш<strong>у</strong>сь',
      'Ты накрас<strong>ишь</strong>ся',
      'Он накрас<strong>ит</strong>ся',
      'Она накрас<strong>ит</strong>ся',
      'Оно накрас<strong>ит</strong>ся',
      'Вы накрас<strong>ите</strong>сь',
      'Мы накрас<strong>им</strong>ся',
      'Они накрас<strong>ят</strong>ся'
    ]
  },
  {
    verb: 'Краси<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я краси<strong>л</strong>ся',
      'Ты краси<strong>л</strong>ся',
      'Он краси<strong>л</strong>ся',
      'Она краси<strong>ла</strong>сь',
      'Оно краси<strong>ло</strong>сь',
      'Вы краси<strong>ли</strong>сь',
      'Мы краси<strong>ли</strong>сь',
      'Они краси<strong>ли</strong>сь'
    ]
  },
  {
    verb: 'Накраси<strong>ть</strong>ся',
    tense: 'Past tense (perfect)',
    set: [
      'Я накраси<strong>л</strong>ся',
      'Ты накраси<strong>л</strong>ся',
      'Он накраси<strong>л</strong>ся',
      'Она накраси<strong>ла</strong>сь',
      'Оно накраси<strong>ло</strong>сь',
      'Вы накраси<strong>ли</strong>сь',
      'Мы накраси<strong>ли</strong>сь',
      'Они накраси<strong>ли</strong>сь'
    ]
  }
];

export const conjVerbsSet6 = [
  {
    verb: 'Собира<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я собира<strong>ю</strong>сь',
      'Ты собира<strong>ешь</strong>ся',
      'Он собира<strong>ет</strong>ся',
      'Она собира<strong>ет</strong>ся',
      'Оно собира<strong>ет</strong>ся',
      'Вы собира<strong>ете</strong>сь',
      'Мы собира<strong>ем</strong>ся',
      'Они собира<strong>ют</strong>ся'
    ]
  },
  {
    verb: 'Собира<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) собира<strong>ть</strong>ся',
      'Ты(будешь) собира<strong>ть</strong>ся',
      'Он(будет) собира<strong>ть</strong>ся',
      'Она(будет) собира<strong>ть</strong>ся',
      'Оно(будет) собира<strong>ть</strong>ся',
      'Вы(будете) собира<strong>ть</strong>ся',
      'Мы(будем) собира<strong>ть</strong>ся',
      'Они(будут) собира<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Собра<strong>ть</strong>ся',
    tense: 'Future tense (perfect)',
    set: [
      'Я собер<strong>у</strong>сь',
      'Ты собер<strong>ешь</strong>ся',
      'Он собер<strong>ет</strong>ся',
      'Она собер<strong>ет</strong>ся',
      'Оно собер<strong>ет</strong>ся',
      'Вы собер<strong>ете</strong>сь',
      'Мы собер<strong>ем</strong>ся',
      'Они собер<strong>ут</strong>ся'
    ]
  },
  {
    verb: 'Собира<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я собира<strong>л</strong>ся',
      'Ты собира<strong>л</strong>ся',
      'Он собира<strong>л</strong>ся',
      'Она собира<strong>ла</strong>сь',
      'Оно собира<strong>ло</strong>сь',
      'Вы собира<strong>ли</strong>сь',
      'Мы собира<strong>ли</strong>сь',
      'Они собира<strong>ли</strong>сь'
    ]
  },
  {
    verb: 'Собра<strong>ть</strong>ся',
    tense: 'Past tense (perfect)',
    set: [
      'Я собра<strong>л</strong>ся',
      'Ты собра<strong>л</strong>ся',
      'Он собра<strong>л</strong>ся',
      'Она собра<strong>ла</strong>сь',
      'Оно собра<strong>ло</strong>сь',
      'Вы собра<strong>ли</strong>сь',
      'Мы собра<strong>ли</strong>сь',
      'Они собра<strong>ли</strong>сь'
    ]
  }
];

export const conjVerbsSet7 = [
  {
    verb: 'Сади<strong>ть</strong>ся',
    tense: 'Present tense (imperfect)',
    set: [
      'Я саж<strong>у</strong>сь',
      'Ты сад<strong>ишь</strong>ся',
      'Он сад<strong>ит</strong>ся',
      'Она сад<strong>ит</strong>ся',
      'Оно сад<strong>ит</strong>ся',
      'Вы сад<strong>ите</strong>сь',
      'Мы сад<strong>им</strong>ся',
      'Они сад<strong>ят</strong>ся'
    ]
  },
  {
    verb: 'Сади<strong>ть</strong>ся',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) сади<strong>ть</strong>ся',
      'Ты(будешь) сади<strong>ть</strong>ся',
      'Он(будет) сади<strong>ть</strong>ся',
      'Она(будет) сади<strong>ть</strong>ся',
      'Оно(будет) сади<strong>ть</strong>ся',
      'Вы(будете) сади<strong>ть</strong>сь',
      'Мы(будем) сади<strong>ть</strong>ся',
      'Они(будут) сади<strong>ть</strong>ся'
    ]
  },
  {
    verb: 'Сес<strong>ть</strong>',
    tense: 'Future tense (perfect)',
    set: [
      'Я сяд<strong>у</strong>',
      'Ты сяд<strong>ешь</strong>',
      'Он сяд<strong>ет</strong>',
      'Она сяд<strong>ет</strong>',
      'Оно сяд<strong>ет</strong>',
      'Вы сяд<strong>ите</strong>',
      'Мы сяд<strong>ем</strong>',
      'Они сяд<strong>ут</strong>'
    ]
  },
  {
    verb: 'Сади<strong>ть</strong>ся',
    tense: 'Past tense (imperfect)',
    set: [
      'Я сад<strong>ил</strong>ся',
      'Ты сад<strong>ил</strong>ся',
      'Он сад<strong>ил</strong>ся',
      'Она сад<strong>ила</strong>сь',
      'Оно сад<strong>ило</strong>сь',
      'Вы сад<strong>или</strong>сь',
      'Мы сад<strong>или</strong>сь',
      'Они сад<strong>или</strong>сь'
    ]
  },
  {
    verb: 'Сес<strong>ть</strong>',
    tense: 'Past tense (perfect)',
    set: [
      'Я сел(а)',
      'Ты сел(а)',
      'Он сел',
      'Она сел<strong>а</strong>',
      'Оно сел<strong>о</strong>',
      'Вы сел<strong>и</strong>',
      'Мы сел<strong>и</strong>',
      'Они сел<strong>и</strong>'
    ]
  }
];

export const conjVerbsSet8 = [
  {
    verb: 'Встава<strong>ть</strong>',
    tense: 'Present tense (imperfect)',
    set: [
      'Я вста<strong>ю</strong>',
      'Ты вста<strong>ёшь</strong>',
      'Он вста<strong>ёт</strong>',
      'Она вста<strong>ёт</strong>',
      'Оно вста<strong>ёт</strong>',
      'Вы вста<strong>ёте</strong>',
      'Мы вста<strong>ём</strong>',
      'Они вста<strong>ют</strong>'
    ]
  },
  {
    verb: 'Встава<strong>ть</strong>',
    tense: 'Future tense (imperfect)',
    set: [
      'Я(буду) встава<strong>ть</strong>',
      'Ты(будешь) встава<strong>ть</strong>',
      'Он(будет) встава<strong>ть</strong>',
      'Она(будет) встава<strong>ть</strong>',
      'Оно(будет) встава<strong>ть</strong>',
      'Вы(будете) встава<strong>ть</strong>',
      'Мы(будем) встава<strong>ть</strong>',
      'Они(будут) встава<strong>ть</strong>'
    ]
  },
  {
    verb: 'Вста<strong>ть</strong>',
    tense: 'Future tense (perfect)',
    set: [
      'Я встан<strong>у</strong>',
      'Ты встан<strong>ешь</strong>',
      'Он встан<strong>ет</strong>',
      'Она встан<strong>ет</strong>',
      'Оно встан<strong>ет</strong>',
      'Вы встан<strong>ите</strong>',
      'Мы встан<strong>ем</strong>',
      'Они встан<strong>ут</strong>'
    ]
  },
  {
    verb: 'Встава<strong>ть</strong>',
    tense: 'Past tense (imperfect)',
    set: [
      'Я встава<strong>л</strong>',
      'Ты встава<strong>л</strong>',
      'Он встава<strong>л</strong>',
      'Она встава<strong>ла</strong>',
      'Оно встава<strong>ло</strong>',
      'Вы встава<strong>ли</strong>',
      'Мы встава<strong>ли</strong>',
      'Они встава<strong>ли</strong>'
    ]
  },
  {
    verb: 'Вста<strong>ть</strong>',
    tense: 'Past tense (perfect)',
    set: [
      'Я встал(а)',
      'Ты встал(а)',
      'Он встал',
      'Она встал<strong>а</strong>',
      'Оно встал<strong>о</strong>',
      'Вы встал<strong>и</strong>',
      'Мы встал<strong>и</strong>',
      'Они встал<strong>и</strong>'
    ]
  }
];